(function() {
	function getListingKey() {
		return window.location.pathname + window.location.search;
	}

	class ProductListing {
		constructor() {
			const $listing = $("#product-listing");
			if (!$listing.length || !window.aracwebshop || !aracwebshop.ProductView) return;
			if (aracwebshop.product_view && typeof aracwebshop.product_view.destroy === "function") {
				aracwebshop.product_view.destroy();
			}

			const is_item_group_page = $(".item-group-content").data("item-group");
			this.item_group = is_item_group_page || null;
			const view_type = localStorage.getItem("product_view") || "Grid View";

			aracwebshop.product_view = new aracwebshop.ProductView({
				view_type: view_type,
				products_section: $listing,
				item_group: this.item_group
			});

			this.bind_card_actions();
		}

		bind_card_actions() {
			const cart = aracwebshop.aracwebshop && aracwebshop.aracwebshop.shopping_cart;
			const wishlist = aracwebshop.aracwebshop && aracwebshop.aracwebshop.wishlist;
			if (cart && cart.bind_add_to_cart_action) cart.bind_add_to_cart_action();
			if (wishlist && wishlist.bind_wishlist_action) wishlist.bind_wishlist_action();
		}
	}

	window.aracwebshop = window.aracwebshop || {};
	window.aracwebshop.init_product_listing = function(force) {
		const $listing = $("#product-listing");
		if (!$listing.length || !window.aracwebshop || !aracwebshop.ProductView) return null;

		const key = getListingKey();
		if (!force && $listing.attr("data-arac-product-listing-key") === key) {
			return aracwebshop.product_listing || null;
		}

		$listing.attr("data-arac-product-listing-key", key);
		aracwebshop.product_listing = new ProductListing();
		return aracwebshop.product_listing;
	};

	$(function() {
		window.aracwebshop.init_product_listing();
	});
})();
